module.exports = "https://r.nearpod.com/assets/media/image/image-header-5dd0534ff76b2b8144af23ebd27219b2.svg";